import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { site } from '../data/site';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-brand">
          <Link className="brand" to="/">
            <img className="brand-logo footer-logo" src={site.logo} alt="K and son’s Guest House logo" width="94" height="94" loading="lazy" />
          </Link>
          <p>{site.welcome}</p>
        </div>
        <div className="footer-links">
          <h2>Explore</h2>
          {site.nav.map((item) => <Link key={item.to} to={item.to}>{item.label}</Link>)}
        </div>
        <div className="footer-links footer-contact">
          <h2>Get in touch</h2>
          <span><SafeIcon name="MapPin" /> {site.address}</span>
          {site.phones.map((phone) => <a key={phone} href={`tel:${phone.replace(/\s/g, '')}`}><SafeIcon name="Phone" /> {phone}</a>)}
          <a href={`mailto:${site.email}`}><SafeIcon name="Mail" /> {site.email}</a>
        </div>
      </div>
      <div className="footer-bottom">
        <span>{site.copyright}</span>
        <span>Thoughtful hospitality, at your own pace.</span>
      </div>
      <a className="floating-whatsapp" href={site.whatsapp} target="_blank" rel="noopener noreferrer" aria-label={`WhatsApp ${site.phones[0]}`}>
        <SafeIcon name="MessageCircle" /> <span>WhatsApp</span>
      </a>
    </footer>
  );
}